export interface PrivacyPolicyLangs {
  [lang: string]: {
    body: string;
    created_at?: string;
    updated_at?: string;
  };
}

export type PrivacyPolicyEntity = {
  id?: number;
  langs?: PrivacyPolicyLangs;
  activation_date?: string;
  mails_sended?: string;
  published?: number;
  created_at?: string;
  updated_at?: string;
};

export default class PrivacyPolicy {
  id?: number;
  langs?: PrivacyPolicyLangs;
  activation_date?: string;
  mails_sended?: string;
  published?: number;
  created_at?: string;
  updated_at?: string;

  constructor(entity: PrivacyPolicyEntity) {
    this.id = entity.id;
    this.langs = entity.langs;
    this.activation_date = entity.activation_date;
    this.mails_sended = entity.mails_sended;
    this.published = entity.published;
    this.created_at = entity.created_at;
    this.updated_at = entity.updated_at;
  }

  static getFilterableAttributes(): string[] {
    return ['activation_date_from', 'activation_date_to'];
  }

  static getSortableAttributes(): string[] {
    return ['activation_date'];
  }

  getIsPublished(): string {
    if (this.published) {
      return 'Yes';
    }

    return 'No';
  }
}

export const createPrivacyPolicy = (
  entity: PrivacyPolicyEntity
): PrivacyPolicy => new PrivacyPolicy(entity);
